import 'leaflet/dist/leaflet.css';
import './Nav.css'
import React, { ReactNode } from 'react'
import { BatteryRemainingData } from '../../../types/Battery';

const yellBatt = 40;

// Телеметрии по батарее нет — сюда приходит -1. Это «неизвестно», а не «разряд»:
// раньше такой случай рисовался жёлтым с подписью 'nan', то есть выглядел как
// предупреждение о низком заряде.
const isUnknown = (battery: number): boolean => battery < 0;

const BatteryImage = React.memo(({ battery }: { battery: number }): ReactNode => {
    const icon = battery < yellBatt
        ? '/image/modem/battery/e_batt.svg'
        : '/image/modem/battery/w_batt.svg';
    return (
        <img
            className={'bat-box-icon' + (isUnknown(battery) ? ' bat-box-icon-unknown' : '')}
            src={icon}
            alt=""
        />
    );
});
BatteryImage.displayName = 'BatteryImage';

const getBatteryText = (battery: number): string => {
    return isUnknown(battery) ? '—' : `${battery}%`;
};

const Battery = React.memo(({ battery }: { battery: number }) => {
    const textStyle = isUnknown(battery)
        ? 'addition-text'
        : battery < yellBatt ? 'addition-yell' : 'addition-white';
    return (
        <div className={`bat-box-text ${textStyle}`}>
            {getBatteryText(battery)}
        </div>
    );
});
Battery.displayName = 'Battery';

interface BatteryBoxProps {
    batteries: BatteryRemainingData[] | null;
}

function BatteryBox({ batteries }: BatteryBoxProps): ReactNode {
    // Данные приходят из хаба. Проверка именно на массив, а не на null и длину:
    // при любом другом формате (объект, число) length была бы undefined, дело
    // доходило до .map, и падение листа сносило всё дерево React.
    const list = Array.isArray(batteries) ? batteries : [];

    return (
        <div className='bat-box'>
            {list.length === 0 ? (
                <div className='bat-ctn'>
                    <div className='bat-box-text-container'>
                        <Battery battery={-1} />
                    </div>
                    <BatteryImage battery={-1} />
                </div>
            ) : (
                list.map((b, i) =>
                    // id может отсутствовать (сервер не всегда присылает его для
                    // единственной батареи) — индекс как запасной key безопасен,
                    // список не переупорядочивается.
                    <div className='bat-ctn' key={b.id ?? i}>
                        <div className='bat-box-text-container'>
                            <Battery battery={b.remaining} />
                        </div>
                        <BatteryImage battery={b.remaining} />
                    </div>
                )
            )}
        </div>
    )
}

export default BatteryBox;